import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { DashboardReportModel } from '@shared/models/dashboard-reports';

import { ApiService } from '@shared/services';
import { Observable } from 'rxjs';
import { ReferralReportsFilters } from '@modules/reports/models/referral-reports-filters';

@Injectable({
  providedIn: 'root',
})
export class MetricsReportService extends ApiService<any> {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'metrics/';
  }

  sendEmailReferralReport(params: ReferralReportsFilters): Observable<DashboardReportModel> {
    return this.post({ url: 'excel/referral-report', body: params });
  }
}
